import { ReactNode } from 'react';

interface LinkProps {
  children: ReactNode;
  href: string;
  className?: string;
  onClick?: () => void;
}

const Link = ({ children, href, className = '', onClick }: LinkProps) => {
  return (
    <a
      href={href}
      className={className}
      onClick={onClick}
      data-testid="cta-subnav-link"
    >
      {children}
    </a>
  );
};

export default Link;
